import React, { Component } from 'react';
import ClickOutHandler from 'react-onclickout';
import { Scrollbars } from 'react-custom-scrollbars';
import { Shake } from 'reshake'

class CartWidget extends Component {

    constructor(){
        super();

        this.state = {
            isOpen: false,
            shake: false
        }

        this.handleToggle = this.handleToggle.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.showCart = this.showCart.bind(this);
    }


    handleToggle = () => {
        this.setState({ isOpen: !this.state.isOpen });
    };

    deleteItem(item){
        const itemToDelete = item.target.attributes.getNamedItem('item').value;
        let reducedCart = this.props.items;
        reducedCart.splice(itemToDelete, 1);
        this.props.onUpdateCart(reducedCart);
    }

    showCart(){
        this.setState({ isOpen: false });
        this.props.onShowCart();
    }

    componentDidUpdate(prevProps){
        if(prevProps.items.length < this.props.items.length){
            this.setState({
                shake: true
            });
        }
    }

    render(){
        let totalCartAmt = 0;        

        if(typeof this.props.items !== 'undefined' && this.props.items.length !== 0){

            const items = this.props.items.map(
                (itm, i)=>{ 
                    let curent_price = 0;
                    if(itm.object.numbeds*1 === 1){
                        if(itm.object.bedsize === 'double' || itm.object.bedsize === 'kingsize'){
                            if(itm.numPersons*1 === 1){
                                curent_price = itm.object.price_1
                            }else{
                                curent_price = itm.object.price;
                            }
                        }else{
                            curent_price = itm.object.price;
                        }
                    }else if(itm.object.numbeds*1 === 2){
                        if(itm.numPersons*1 === 1){
                            curent_price = itm.object.price_1
                        }else{
                            curent_price = itm.object.price;
                        }
                    }else{
                        if(itm.object.numbeds*1 === itm.numPersons*1){
                            curent_price = itm.object.price;
                        }else{
                            if(itm.numPersons*1 === 1){
                                curent_price = itm.object.price_1;                   
                            }else if(itm.numPersons*1 === 2){
                                curent_price = itm.object.price_2;
                            }else if(itm.numPersons*1 === 3){
                                curent_price = itm.object.price_3;
                            }else{
                                curent_price = itm.object.price;
                            }             
                        }            
                    }   
                    const additionalPrice = itm.earlyCheckIn*itm.object.earlycheckin + 
                                    itm.lateCheckOut*itm.object.latecheckout +
                                    itm.breakfast*itm.numbreakfast*itm.object.breakfastprice +
                                    itm.dinner*itm.numdinner*itm.object.dinnerprice;
                    const numNights  = itm.dateInterval ? Math.round(itm.dateInterval / 86400 / 1000) : 1;
                    const total = (curent_price - (itm.promocode ? itm.object.promodiscount : 0) + additionalPrice) * numNights;
                    totalCartAmt+=total;
                    return( 
    
                        <div className="vb-minicart-container" key={i}>
                            <button className="vb-mini-close" item={i} onClick={this.deleteItem}>
                                <svg item={i} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path item={i} fillRule="evenodd" clipRule="evenodd" d="M9.19238 0.707092L8.48523 0L4.59619 3.88904L0.707153 0L0 0.707092L3.88904 4.59619L0 8.48529L0.707031 9.19238L4.59619 5.30328L8.48523 9.19238L9.19238 8.48529L5.30334 4.59619L9.19238 0.707092Z" fill="#4F4F4F"/>
                                </svg>					
                            </button>
                                <div className="vb-minicart-photo" style={{'backgroundImage': 'url("'+itm.object.photos[0]+'")'}}></div>
                                <div className="vb-minicart-contentbox">
                                    <div className="vb-minicart-header">
                                        <h2>{itm.object.name}</h2>
                                    </div>
                                    <div className="vb-minicart-content">
                                        <div className="vb-minicart-text">
                                            <div className="vb-minicart-data">
                                                <span>{itm.dateInterval.start.format("MM/DD/YYYY")}</span>
                                            </div>
                                            <div className="vb-minicart-man">
                                                <span>{itm.numPersons}</span>
                                            </div>
                                            <div className="vb-minicart-moon">
                                                <span>{itm.dateInterval ? Math.round(itm.dateInterval / 86400 / 1000) : 1}</span>
                                            </div>
                                            <div className="vb-minicart-price">
                                                <p>{total}kr</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        
                    )
                }
            );

            let height = this.props.items.length*90
            if(height > 450){
                height = 450;
            }

            return(
                <div className="cartWidget">
                    <span className={this.state.isOpen ? "vb-cart full openWidget" : "vb-cart full"} href="#cart" onClick={this.handleToggle}>
                        <span className="cart-num-items">({this.props.items.length} item{this.props.items.length > 1 ? 's' :''})</span>&nbsp;&nbsp;	
                    {this.state.shake ? 
                        <Shake  h={10}
                                v={0}
                                r={40}
                                dur={300}
                                int={50}
                                max={100}
                                fixed={true}
                                fixedStop={false}
                                freez={false}
                                q={3}
                                tf='ease-out' >
                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.8899 5.13761L8.66055 0.293578C8.51373 0.146789 8.29358 0 8.07339 0C7.85321 0 7.63303 0.0733945 7.48624 0.293578L4.25688 5.13761H0.733945C0.293578 5.13761 0 5.43119 0 5.87156C0 5.94495 0 6.01835 0 6.09174L1.83486 12.9174C1.98165 13.5046 2.56881 14.0183 3.22936 14.0183H12.7706C13.4312 14.0183 14.0183 13.578 14.1651 12.9174L16 6.09174C16 6.01835 16 5.94495 16 5.87156C16 5.43119 15.7064 5.13761 15.2661 5.13761H11.8899ZM5.87156 5.13761L8.07339 1.90826L10.2752 5.13761H5.87156ZM8.07339 11.0092C7.26605 11.0092 6.6055 10.3486 6.6055 9.54128C6.6055 8.73394 7.26605 8.07339 8.07339 8.07339C8.88073 8.07339 9.54128 8.73394 9.54128 9.54128C9.54128 10.3486 8.88073 11.0092 8.07339 11.0092Z" fill="white"/>
                                <circle cx="8" cy="9" r="2" fill="#FF0000"/>
                            </svg>
                        </Shake>
                    : 
                        <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.8899 5.13761L8.66055 0.293578C8.51373 0.146789 8.29358 0 8.07339 0C7.85321 0 7.63303 0.0733945 7.48624 0.293578L4.25688 5.13761H0.733945C0.293578 5.13761 0 5.43119 0 5.87156C0 5.94495 0 6.01835 0 6.09174L1.83486 12.9174C1.98165 13.5046 2.56881 14.0183 3.22936 14.0183H12.7706C13.4312 14.0183 14.0183 13.578 14.1651 12.9174L16 6.09174C16 6.01835 16 5.94495 16 5.87156C16 5.43119 15.7064 5.13761 15.2661 5.13761H11.8899ZM5.87156 5.13761L8.07339 1.90826L10.2752 5.13761H5.87156ZM8.07339 11.0092C7.26605 11.0092 6.6055 10.3486 6.6055 9.54128C6.6055 8.73394 7.26605 8.07339 8.07339 8.07339C8.88073 8.07339 9.54128 8.73394 9.54128 9.54128C9.54128 10.3486 8.88073 11.0092 8.07339 11.0092Z" fill="white"/>
                            <circle cx="8" cy="9" r="2" fill="#FF0000"/>
                        </svg>
                    }                        						
                    </span>
                    {this.state.isOpen ?
                    <ClickOutHandler onClickOut={this.handleToggle}>                        
                        <div className="vb-mini-cart">
                            <div className="vb-minicart-box">
                                <Scrollbars style={{ height: height }}>
                                {items}
                                </Scrollbars>
                                <div className="vb-minicart-total">
                                    <div className="vb-minicart-totalprice">
                                        <span>Total:</span>
                                        <p>{totalCartAmt}kr</p>
                                    </div>
                                    <div className="vb-minicart-button">
                                        <button  className="vb-minicart-backtosearch" onClick={this.handleToggle}>back to search</button>
                                        <button className="vb-minicart-order" onClick={this.showCart}>Order</button>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </ClickOutHandler>
                    : ""}
                </div>
            )
        }else{
            return(
                <span className="vb-cart" href="#cart" title="">
					<svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M11.8899 5.13761L8.66055 0.293578C8.51373 0.146789 8.29358 0 8.07339 0C7.85321 0 7.63303 0.0733945 7.48624 0.293578L4.25688 5.13761H0.733945C0.293578 5.13761 0 5.43119 0 5.87156C0 5.94495 0 6.01835 0 6.09174L1.83486 12.9174C1.98165 13.5046 2.56881 14.0183 3.22936 14.0183H12.7706C13.4312 14.0183 14.0183 13.578 14.1651 12.9174L16 6.09174C16 6.01835 16 5.94495 16 5.87156C16 5.43119 15.7064 5.13761 15.2661 5.13761H11.8899ZM5.87156 5.13761L8.07339 1.90826L10.2752 5.13761H5.87156ZM8.07339 11.0092C7.26605 11.0092 6.6055 10.3486 6.6055 9.54128C6.6055 8.73394 7.26605 8.07339 8.07339 8.07339C8.88073 8.07339 9.54128 8.73394 9.54128 9.54128C9.54128 10.3486 8.88073 11.0092 8.07339 11.0092Z" fill="white"/>
					</svg>									
				</span>
            )
        }
    }
}

export default CartWidget;